<template>
  <div class="settings">
    <div class="row">
      <h2>Please Review the Subscription Changes:</h2>

      <h3>Current Plan</h3>
      <p>Plan: {{ current_plan }}</p> 
      <p>Term: {{ current_term }}</p> 
      <p>Ending: {{ current_end }}</p> 

      <h3>New Plan</h3>
      <p>Plan: {{ new_plan }}</p> 
      <p>Term: {{ new_term }}</p> 
      <p>Start: {{ new_start }}</p> 
      <br>
      <br>
      <div >
        <button class="button button-cancel " @click="close()">Cancel</button>
        <button class="button button-ok" @click="select()">Confirm and Proceed</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

import {  defineEmits } from "vue";
const emit = defineEmits(['selection_end']);

const props = defineProps({ 
  current_plan: String,
  current_term: String,
  current_end: String,
  new_plan: String,
  new_term: String,
  new_start: String,
  new_payment: String,

});

function close() {
  emit('selection_end','cancel');
}

function select() {
  emit('selection_end','ok');
}

async function subscribe(term) {
  const dsConn = new DatastoreConnect();
  const success_url = `${window.location.origin}/#/admin/transactions`;
  const fail_url = `${window.location.origin}/#/admin/payment_fail`;
  const ret = await dsConn.paymentSubscribe({
    plan: new_plan.value, term, success: success_url, fail: fail_url,
  });

  if (ret.result) {
    const url = ret.result["url"];
    window.location.replace(url);
  }
}



</script>

<style lang="scss" scoped>

.button-cancel {
  margin: 4px;
  background: rgb(67, 67, 67);
}
.button-ok {
  margin: 4px;
}

.settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}

.header {
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

</style>
